module.exports = __webpack_public_path__ + "static/media/logo.f1edf571.png";